import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

const TotalOrdersByDate = ({
  totalOrdersChartByDate,
  totalOrdersChartByValue,
}) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chartInstance = echarts.init(chartRef.current);

    const option = {
      title: {
        text: "Total Orders by Date",
      },
      tooltip: {
        trigger: "axis", // Enables tooltip on axis hover
        axisPointer: {
          type: "cross", // Shows a crosshair line on hover
        },
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: totalOrdersChartByDate,
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          data: totalOrdersChartByValue,
          name: "Order",
          type: "line",
          areaStyle: {},
          smooth: true, // Smooth the line curve
          lineStyle: {
            width: 2, // Set line thickness
          },
          emphasis: {
            focus: "series", // Highlight the entire series on hover
          },
        },
      ],
    };

    chartInstance.setOption(option);

    const handleResize = () => {
      chartInstance.resize();
    };
    window.addEventListener("resize", handleResize);

    return () => {
      chartInstance.dispose();
      window.removeEventListener("resize", handleResize);
    };
  }, [totalOrdersChartByDate, totalOrdersChartByValue]);

  return (
    <div
      ref={chartRef}
      style={{
        width: "100%",
        height: "300px", // Fixed height for the parent
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "16px",
        boxSizing: "border-box",
      }}
    ></div>
  );
};

export default TotalOrdersByDate;
